import { Component, inject } from '@angular/core'

import { DialogType, DownloadItem } from './dialog-application.models'
import { TranslatePipe } from '@ngx-translate/core'
import {
  IMAGE_BASE_PATH,
  INSTALLER_CONFIG_BY_APPLICATION,
  NOT_INSTALLATION_ALLOWED,
  SHOW_OS_ICON_APPLICATIONS,
} from './dialog-application.constants'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { DialogBase } from '@shared/dialogs/models/dialog.base'
import { DownloadableAsset, getAssets } from '@domains/assets'
import { getHeader } from './dialog-application.utils'
import { DeviceDetector } from '@system/device-detector'
import { ApplicationMenuModels } from '@system/application'
import { ApplicationName, Button, DefaultImageDirective, SafePipe } from '@performance/ui'
import { Profile } from '@domains/profile'

import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'mcp-dialog-application',
  templateUrl: './dialog-application.html',
  styleUrls: ['./dialog-application.scss'],

  imports: [DefaultImageDirective, TranslatePipe, SafePipe, Button, AsyncPipe],
})
export class DialogApplication extends DialogBase<{
  type: DialogType
  application: ApplicationMenuModels
  userProfile: Profile
}> {
  private readonly _deviceDetector: DeviceDetector = inject(DeviceDetector)

  readonly imageBasePath = IMAGE_BASE_PATH
  readonly appWithOSIcon = SHOW_OS_ICON_APPLICATIONS

  get type(): DialogType {
    return this.data?.type
  }

  get application(): ApplicationMenuModels {
    return this.data?.application
  }
  get isDesktop(): boolean {
    return this._deviceDetector.isDesktop()
  }

  get isTablet(): boolean {
    return this._deviceDetector.isTablet()
  }

  get isMobile(): boolean {
    return this._deviceDetector.isMobile()
  }

  get deviceOs(): string {
    return this._deviceDetector.getDeviceInfo()?.os
  }

  backgroundImage: string
  headerImages = []
  notInstallationAllowed = false

  downloadList$: Observable<DownloadItem[]> = getAssets().pipe(
    filter(() => !!this.application && !!this.type),
    map((assets) =>
      this.type === DialogType.Download
        ? this._getDownloadList(assets, this.application.name as ApplicationName)
        : undefined,
    ),
  )

  constructor() {
    super()
    this.notInstallationAllowed =      NOT_INSTALLATION_ALLOWED[this.application?.name] &&
      NOT_INSTALLATION_ALLOWED[this.application?.name](this)

    this.headerImages = getHeader(this.type, this.application?.name)
  }

  private _getDownloadList(assets: DownloadableAsset[], applicationName: ApplicationName) {
    const installers = assets.filter(({ groupType }) => groupType === `${applicationName}Installer`)
    return [
      ...INSTALLER_CONFIG_BY_APPLICATION[applicationName].map((item) => ({
        ...item,
        url: [ApplicationName.Mobile, ApplicationName.Desktop].includes(applicationName)
          ? ((installers || []).find((appItem) => appItem.extension === item.extension) || {}).path
          : installers[0].path,
      })),
    ]
  }
}
